/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Psod_Error_ReportInputs */

const fr_psod_error_report = /** @type {(inputs: Psod_Error_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapport d'erreur`)
};

const en_psod_error_report = /** @type {(inputs: Psod_Error_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error report`)
};

/**
* | output |
* | --- |
* | "Error report" |
*
* @param {Psod_Error_ReportInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const psod_error_report = /** @type {((inputs?: Psod_Error_ReportInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Psod_Error_ReportInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_psod_error_report(inputs)
	return en_psod_error_report(inputs)
});